import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./plugins/vant.js";
import "./plugins/axios";

// 适配方案
import "lib-flexible/flexible.js";

// 公共样式
import "@/assets/css/common.scss";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
